export default {"src":"/_next/static/image/public/imgs/eagleshare-logo.f9d8d7fd58bf9768f554cdf810dc42ec.svg","height":69,"width":659};